import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const ResultsEmptyStateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
`;

export const Header = styled.div`
    ${FONT_FAMILY.poppins};
    color: ${TC.heading};
    text-align: center;
    ${DESKTOP_SIZES[SIZES.HEADING_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.HEADING_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_SM].fontWeight};
    margin-top: 24px;
    margin-bottom: 8px;
`;

export const Subtitle = styled.div`
    ${FONT_FAMILY.poppins};
    color: ${TC.body};
    text-align: center;
    ${DESKTOP_SIZES[SIZES.BODY_MD_MED].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
`;
